import { Component, Input } from '@angular/core';
import { LinkedAttachmentDto } from '@app/api';
import { UiCommandEvent } from '@cer/cer-ui/cer-ui-types';

import { CerFormView } from '@form/cer-form-view';

@Component({
  selector: 'cer-form-view-type-document-folder',
  template: `<div class="cer-flex cer-flex-main cer-flex-center"><table>
    <tr><td>Folder</td><td>{{fileName}}</td></tr>
    <tr><td>Oprettet</td><td> {{attachment?.created}}</td></tr>
  </table></div>`
})

export class CerFormViewTypeDocumentFolderComponent {

  onCommand(e: UiCommandEvent): void {
    throw new Error('Method not implemented.');
  }

  protected fileName: string;
  
  private _view: CerFormView;
  get view(): CerFormView { return this._view; };
  @Input() set view(view: CerFormView) {
    if (view && this._view != view) {
      this._view = view;
      this.documentUrl = view?.documentUrl;
      view.commandSubscribe((e) => this.onCommand(e));
    }
  }

  @Input() attachment: LinkedAttachmentDto;
  
  private _documentUrl!: string;
  get documentUrl(): string { return this._documentUrl };
  @Input() set documentUrl(documentUrl: string) {
    const dataFromParent = this.view?.dataFromParent?.length > 0 ? this.view?.dataFromParent[0] : null;
    if (documentUrl != this._documentUrl || this.attachment != dataFromParent) {
      this.attachment = dataFromParent;
      if (this._view.documentType == 'folder') {
        this.fileName = this._view.documentFileName;
      }
    }
  }
}